
import React from 'react';
import { useLogoUrl } from '@/hooks/useLogoUrl';

const FooterBranding: React.FC = () => {
  const logoUrl = useLogoUrl();

  return (
    <div className="mb-6 md:mb-0">
      {logoUrl ? (
        <img 
          src={logoUrl} 
          alt="Company Logo" 
          className="h-10 w-auto object-contain mb-2" 
        />
      ) : (
        <>
          <div className="flex items-center mb-2">
            <img 
              src="/lovable-uploads/36c87bd9-7bdf-4413-bf74-70043278eb04.png"
              alt="ReferMe Logo"
              className="h-8 w-auto mr-2 object-contain"
            />
            <h2 className="text-primary-blue text-lg font-bold">ReferMe.site</h2>
          </div>
          <p className="text-gray-600 text-sm">Refer friends, earn rewards</p>
        </>
      )}
    </div>
  );
};

export default FooterBranding;
